import { getSheetIdToStatusMap, useDsdTaskStatus } from "@/components/sidebar/hooks";
import { isSheetAnalyzing } from "@/components/sidebar/task-status";
import { useCategoryId, useWorkbookId } from "@/hooks/use-workbook";

/**
 * 현재 열려 있는 시트가 XBRL 분석 중(RUNNING/PENDING) 이거나 role 재배정 중
 * (ADJUSTING_ROLE)인지 여부.
 *
 * 워크북이 XBRL_ANALYZED 여도 개별 시트는 아직 분석 중일 수 있으므로, 워크북 단위
 * `useIsWorkbookAnalyzed` 만으로는 분석 중인 시트에서 롤포워드/오토태깅이 막히지 않는다.
 * 이 훅은 현재 시트의 task 상태를 보고 그 시트 대상 액션을 비활성화하는 데 쓴다.
 */
export function useIsCurrentSheetAnalyzing(): boolean {
  const { data: workbookId } = useWorkbookId();
  const { data: categoryId } = useCategoryId();
  const { data: taskStatusData } = useDsdTaskStatus(workbookId ?? undefined);

  if (!taskStatusData || !categoryId) return false;

  return isSheetAnalyzing(getSheetIdToStatusMap(taskStatusData)[categoryId]);
}
